import module from 'nominas/nomina/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class NominasFiniquitoEscenarioCalculoCalcularComponent {
  data
  onClose
  obtenerInformacion = null
  script = null
  worker = null
  completado = false
  resultado = null
  error = null
  catalogo = {
    conceptos: [],
    imssImpuestos: [],
    impuestos: [],
    subsidios: [],
    diasVacaciones: [],
  }

  constructor ($filter, $http, $q, $window, $worker, CatalogoDiasVacaciones, CatalogoFiniquitoConceptos, CatalogoImpuestos, CatalogoImssImpuestos, CatalogoSubsidios) {
    this.$filter = $filter
    this.$http = $http
    this.$q = $q
    this.$window = $window
    this.$worker = $worker
    this.CatalogoDiasVacaciones = CatalogoDiasVacaciones
    this.CatalogoFiniquitoConceptos = CatalogoFiniquitoConceptos
    this.CatalogoImpuestos = CatalogoImpuestos
    this.CatalogoImssImpuestos = CatalogoImssImpuestos
    this.CatalogoSubsidios = CatalogoSubsidios
  }

  $onInit () {
    this.obtenerInformacion = this.$q.defer()

    let promise = this.$q.all([
        this.$http.get('/api/nominas/calculo/script', {responseType: 'blob'})
          .then((response) => (this.script = this.$window.URL.createObjectURL(response.data))),
        this.CatalogoFiniquitoConceptos.get({id_proyecto: this.data.id_proyecto})
          .then((response) => (this.catalogo.conceptos = orderBy(response.data, 'orden'))),
        this.CatalogoImpuestos.get()
          .then((response) => (this.catalogo.impuestos = response.data)),
        this.CatalogoImssImpuestos.get()
          .then((response) => (this.catalogo.imssImpuestos = response.data)),
        this.CatalogoSubsidios.get({id_tipo_nomina: this.data.configuracion.tarifa})
          .then((response) => (this.catalogo.subsidios = response.data)),
        this.CatalogoDiasVacaciones.get()
          .then((response) => (this.catalogo.diasVacaciones = response.data)),
      ])
      .then(() => (this.obtenerInformacion.resolve()))

    this.$q.all([promise, this.obtenerInformacion.promise])
      .then(() => (this.calcular()))
      .catch((response) => (this.postError(response.data)))
  }

  $onDestroy () {
    this.terminar()
  }

  calcular () {
    this.worker = new this.$worker(this.script)
    this.worker.onmessage((event) => (this.postSuccess(event.data)))
    this.worker.onerror((event) => (this.postError(event.message)))
    this.worker.postMessage({
      indice: 0,
      colaborador: this.data.colaborador,
      configuracion: this.data.configuracion,
      conceptos: this.catalogo.conceptos,
      impuestos: this.catalogo.impuestos,
      subsidios: this.catalogo.subsidios,
      imssImpuestos: this.catalogo.imssImpuestos,
      diasVacaciones: this.catalogo.diasVacaciones,
    })
  }

  postSuccess (data) {
    if (data.error) {
      this.postError(data.error)

      return
    }

    this.resultado = data.colaborador
    this.completado = true

    Object.values(this.resultado.percepciones).forEach((concepto) => (this.asignarConcepto(concepto)))
    Object.values(this.resultado.deducciones).forEach((concepto) => (this.asignarConcepto(concepto)))

    this.terminar()
    this.cerrar()
  }

  postError (error) {
    console.error(error)
    this.error = `Error: ${error}`
    this.terminar()
  }

  cancelar () {
    this.obtenerInformacion.reject()
    this.terminar()
    this.cerrar()
  }

  cerrar () {
    let detail = {
      resultado: this.resultado,
      error: this.error,
      completado: this.completado,
    }

    this.onClose({$event: {detail}})
  }

  terminar () {
    if (this.worker) {
      this.worker.terminate()
      this.worker = null
    }

    if (this.script) {
      this.$window.URL.revokeObjectURL(this.script)
      this.script = null
    }
  }

  asignarConcepto (concepto) {
    concepto.descripcion = (this.catalogo.conceptos.find((item) => Number(item.id) === concepto.id_concepto) || {concepto: 'Desconocido'}).concepto
  }
}

module.component('nominasFiniquitoEscenarioCalculoCalcular', {
  controller: NominasFiniquitoEscenarioCalculoCalcularComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/finiquito/components/escenario/calculo/calcular/component.js